<app-base-modal
  [title]="'Настройки профиля'"
>
  <div class="profile">
    @if (profileColumnDialogData.currentProfileName) {
      <mat-form-field
        appearance="outline"
        class="profile-field none-pointer-events"
      >
        <mat-label>Текущее название профиля</mat-label>
        <input
          matInput
          required
          [(ngModel)]="profileColumnDialogData.currentProfileName"
        >
      </mat-form-field>
    }
    <mat-form-field
      appearance="outline"
      class="profile-field"
    >
      <mat-label>Новое название профиля</mat-label>
      <input
        matInput
        required
        [(ngModel)]="newProfileName"
      >
    </mat-form-field>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="!this.newProfileName"
      (click)="handleSaveBtn()"
    >
      Сохранить
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
